<template>
  <div class="cascader-site">
    <a-row type="flex" :gutter="16">
      <a-col flex="39%">
        <app-cascader-province v-bind="$attrs" @upDateData="upDateDataProvince" @textSetUp="textSetUp"/>
      </a-col>
      <a-col flex="56.5%" class="col-width">
        <app-getAddress-BD ref="appGetAddressBD" v-bind="$attrs" :province-text="provinceText" @updateAddress="updateAddress"  @updateData="upDateDataAddress"/>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import appCascaderProvince from "@/components/app-cascader-province";
import appGetAddressBD from "@/components/app-getAddress-BD";



export default {
  components: {
    appCascaderProvince,
    appGetAddressBD
  },
  props:{
  },
  data() {
    return {
      options: [],
      province:{},
      provinceText:'',
      addressDetails:{},

    };
  },
  methods: {
    textSetUp(data) {
      this.provinceText = data
    },
    upDateDataProvince(value){
      const {provinceCode,provinceText} = value
      
      this.province = {
        provinceCode:provinceCode[0] || '',
        cityCode:provinceCode[1] || '',
        countyCode:provinceCode[2] || ''
      }
      this.provinceText = provinceText
      this.$emit('updateData',{...this.province})
      this.$refs.appGetAddressBD.clearData()
    },
    upDateDataAddress(value, provinceText){
      if (provinceText) {
        this.addressDetails = value
        this.provinceText = provinceText ? this.provinceText : provinceText
        this.$emit('updateData',{...this.addressDetails,...this.province})
      }
    },
    updateAddress(val) {
      this.$emit('updateAddress', val)
    }
    
  },
};
</script>
<style scoped >
.cascader-site .cascader,
.cascader-site .select {
  width: 100% !important;
}
.col-width{
  max-width: 100%;
}
</style>